import React from 'react';
import { CircularProgress } from '@mui/material';

const Loader = () => {
  return (
    <div className="">
      <CircularProgress size={20} />
    </div>
  );
};
export default Loader;
